module.exports = __webpack_public_path__ + "img/18J_iCKHTzzXoc12sHhnT-ZVBfXoJtEEL.87bedbfb.png";